<template>
  <div class="container-fluid">
    <template
      v-if="
        possibleItems.list.groups &&
        !$parent.$parent.$parent['isCurrentItemBasicModel'](currentItemId)
      "
    >
      <div
        class="row border-bottom"
        v-for="(item, index) in possibleItems.list.groups"
        v-bind:key="index"
      >
        <div
          class="col-6 text-start"
          style="cursor: pointer"
          @click="configure('stones/group/' + index + '/0')"
          v-if="
            itemData.description && itemData.description.stones.groups[index]
          "
        >
          <h5>{{ $t("Menu.list.stones.groups.stoneGroup") }}</h5>
          <p v-if="item.side == 1">
            {{ $t("Menu.list.stones.groups.outside") }}
          </p>
          <p v-if="item.side == 2">{{ $t("Menu.list.stones.groups.left") }}</p>
          <p v-if="item.side == 3">{{ $t("Menu.list.stones.groups.right") }}</p>
          <p v-if="item.side == 4">
            {{ $t("Menu.list.stones.groups.inside") }}
          </p>
          <p v-html="getStoneGroupTitle(index, false)"></p>
        </div>
        <div
          class="col-4 text-start"
          @click="configure('stones/group/' + index + '/0')"
        >
          <br />
          <div class="addon-list" v-if="item.addons.length > 0">
            <template v-for="(addonId, index) in item.addons">
              <img
                v-if="index < 5"
                v-bind:key="'addon-' + index"
                :src="imageHost + '/conf2010/addons/addon_' + addonId + '.jpg'"
                :alt="addonId"
                class="thumb"
                :class="'addon-thumb-' + index"
              />
            </template>
          </div>
          <template v-else>
            <img
              v-if="item.side == 1"
              :src="appUrl + '/img/assets/stones/settings/AA_g.jpg'"
              :srcset="appUrl + '/img/assets/stones/settings/AA_g@2x.jpg'"
              class="thumb"
            />
            <img
              v-if="item.side == 4"
              :src="appUrl + '/img/assets/stones/innen_g.jpg'"
              :srcset="appUrl + '/img/assets/stones/innen_g@2x.jpg'"
              class="thumb"
            />
            <img
              v-if="item.side == 2"
              :src="appUrl + '/img/assets/stones/seite_links_g.jpg'"
              :srcset="appUrl + '/img/assets/stones/seite_links_g@2x.jpg'"
              class="thumb"
            />
            <img
              v-if="item.side == 3"
              :src="appUrl + '/img/assets/stones/seite_rechts_g.jpg'"
              :srcset="appUrl + '/img/assets/stones/seite_rechts_g@2x.jpg'"
              class="thumb"
            />
          </template>
        </div>
        <div class="col-2 text-end">
          <template
            v-if="item.stones && item.stones.length > 1 && !item.libraryStoneId"
          >
            <img
              :src="appUrl + '/img/icons/drop.svg'"
              class="icon stone-group"
              @click="changeItemByVarValue('drop-group_' + index)"
            />
          </template>
          <template v-else>
            <img
              :src="appUrl + '/img/icons/edit.svg'"
              class="icon stone-group"
              @click="configure('stones/group/' + index + '/0')"
            />
            <img
              :src="appUrl + '/img/icons/drop.svg'"
              class="icon stone-group"
              @click="changeItemByVarValue('drop-group_' + index)"
            />
          </template>
        </div>
        <template
          v-if="item.stones && item.stones.length < 2 && !item.libraryStoneId"
        >
          <div class="col-12 text-start">
            <img
              v-if="item.side == 1"
              class="item-plan outside"
              @click="configure('stones/group/' + index + '/0')"
              :src="
                getApiHost +
                '/v2/images/plan/outside/false/' +
                index +
                '/0/10/' +
                itemData.size +
                '/' +
                itemData.itemnumber +
                '.jpg'
              "
              alt=""
              width="100%"
            />
          </div>
        </template>
        <template
          v-else-if="
            itemData.description.stones.groups[index] && !item.libraryStoneId
          "
        >
          <div
            class="row text-start stone-col"
            v-for="(stoneItem, stoneKey) in item.stones"
            v-bind:key="stoneKey"
          >
            <div class="col-12">
              <p style="margin: 1.5rem 0 0 0">
                {{
                  itemData.description.stones.groups[index].stones[stoneKey]
                    .type
                }}
                {{
                  itemData.description.stones.groups[index].stones[stoneKey]
                    .number
                }}
                x
                {{
                  $n(
                    itemData.description.stones.groups[index].stones[stoneKey]
                      .size,
                    "carat"
                  )
                }}
                ct. -
                {{
                  itemData.description.stones.groups[index].stones[stoneKey]
                    .qualityShort
                }}
              </p>
            </div>
            <div class="col-10 col-sm-11 col-md-10">
              <img
                class="item-plan outside"
                @click="configure('stones/group/' + index + '/' + stoneKey)"
                :src="
                  getApiHost +
                  '/v2/images/plan/outside/false/' +
                  index +
                  '/' +
                  stoneKey +
                  '/10/' +
                  itemData.size +
                  '/' +
                  itemData.itemnumber +
                  '.jpg'
                "
                alt=""
                width="100%"
              />
              <button
                class="btn-xs btn-block"
                style="border-radius: revert; margin-top: 1rem"
                @click="
                  changeItemByVarValue('loose-stone_' + index + '_' + stoneKey)
                "
              >
                {{ $t("Menu.list.stones.groups.looseStone") }}
              </button>
            </div>
            <div class="col-2 col-sm-1 col-md-2 text-end p-0">
              <img
                :src="appUrl + '/img/icons/edit.svg'"
                class="icon stone"
                @click="configure('stones/group/' + index + '/' + stoneKey)"
              />
              <img
                :src="appUrl + '/img/icons/drop.svg'"
                class="icon stone"
                @click="
                  changeItemByVarValue('drop-stone_' + index + '_' + stoneKey)
                "
              />
            </div>
          </div>
        </template>
      </div>
    </template>
    <template
      v-if="
        possibleItems.list.summarize && possibleItems.list.summarize.length > 1
      "
    >
      <div class="row border-bottom">
        <div v-if="!summarizeStone.show" class="col-12 text-start">
          <button
            class="btn btn-secondary btn-block"
            @click="summarizeStone.show = true"
          >
            {{ $t("Menu.list.stones.groups.summarize.button1") }}
          </button>
        </div>
        <div v-else class="col-12 text-start">
          <div class="row">
            <div class="col-10">
              <h5 class="headline-stone-summarize">
                {{ $t("Menu.list.stones.groups.summarize.headline") }}
              </h5>
            </div>
            <div class="col-2 text-end">
              <img
                :src="appUrl + '/img/icons/close.svg'"
                class="icon"
                style="margin: 0.75rem 0 0 0"
                @click="summarizeStone.show = false"
              />
            </div>
          </div>
          <div class="col-12">
            <p>{{ $t("Menu.list.stones.groups.summarize.note") }}</p>
            <select class="form-control" v-model="summarizeStone.fromGroup">
              <option
                v-for="(stoneGroup, index) in possibleItems.list.summarize"
                v-bind:key="'from_' + index + '_' + stoneGroup"
                :value="stoneGroup"
              >
                {{ getStoneGroupTitle(stoneGroup, true) }}
              </option>
            </select>
            <img
              v-if="summarizeStone.fromGroup >= 0"
              class="item-plan outside"
              @click="
                configure('stones/group/' + summarizeStone.fromGroup + '/0')
              "
              :src="
                getApiHost +
                '/v2/images/plan/outside/false/' +
                summarizeStone.fromGroup +
                '/0/10/' +
                itemData.size +
                '/' +
                itemData.itemnumber +
                '.jpg'
              "
              alt=""
              width="100%"
            />
            <p style="margin-top: 1rem; font-weight: bold">
              {{ $t("Menu.list.stones.groups.summarize.text1") }}
            </p>
            <select
              class="form-control"
              style="margin-top: 0.5rem"
              v-model="summarizeStone.toGroup"
            >
              <option
                v-for="(stoneGroup, index) in possibleItems.list.summarize"
                v-bind:key="'to_' + index + '_' + stoneGroup"
                :value="stoneGroup"
              >
                {{ getStoneGroupTitle(stoneGroup, true) }}
              </option>
            </select>
            <img
              v-if="summarizeStone.toGroup >= 0"
              class="item-plan outside"
              @click="
                configure('stones/group/' + summarizeStone.toGroup + '/0')
              "
              :src="
                getApiHost +
                '/v2/images/plan/outside/false/' +
                summarizeStone.toGroup +
                '/0/10/' +
                itemData.size +
                '/' +
                itemData.itemnumber +
                '.jpg'
              "
              alt=""
              width="100%"
            />
            <button
              class="btn btn-secondary btn-block"
              style="margin: 2rem 0 1rem 0; border-color: #ccc"
              @click="
                changeItemByVarValue(
                  'join-stone_' +
                    summarizeStone.fromGroup +
                    '_' +
                    summarizeStone.toGroup +
                    '_' +
                    summarizeStone.fromGroup
                )
              "
            >
              {{ $t("Menu.list.stones.groups.summarize.button2") }}
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-if="possibleItems.list.qualities">
      <div class="row border-bottom">
        <div class="col-12 text-start">
          <h5 class="headline-stone-quality">
            {{
              $t("Menu.list.stones.groups.qualityOfAllStones", {
                color: possibleItems.list.qualityName,
              })
            }}
          </h5>
          <div
            class="row quality-line"
            v-for="(item, index) in possibleItems.list.qualities"
            v-bind:key="index"
            :class="{ on: item.match }"
            @click="changeItem(item.itemnumber)"
          >
            <div class="col-8">{{ item.text }}</div>
            <div class="col-4 text-end">
              {{ $n(item.price, "currency") }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <div
      class="row"
      v-if="!$parent.$parent.$parent['isCurrentItemBasicModel'](currentItemId)"
    >
      <div class="col-12">
        <h5>{{ $t("Menu.list.stones.groups.addStone") }}</h5>
      </div>
    </div>
    <template
      v-if="
        possibleItems.list &&
        possibleItems.list.common &&
        !$parent.$parent.$parent['isCurrentItemBasicModel'](currentItemId)
      "
    >
      <div class="row border-bottom">
        <div class="col-12 text-center">
          <div @click="configure('stones/library')" class="add-stone">
            <img
              :src="appUrl + '/img/assets/stones/settings/AA_g.jpg'"
              :srcset="appUrl + '/img/assets/stones/settings/AA_g@2x.jpg'"
              class="thumb"
            />
            <p>
              {{ $t("Menu.list.stones.groups.outside") }}
            </p>
          </div>
          <template v-for="(defStone, defStoneId) in possibleItems.list.common">
            <div
              v-if="defStoneId.substr(0, 3) == 'def'"
              @click="changeItem(defStone.itemnumber)"
              class="add-stone"
              :key="defStoneId"
            >
              <img
                class="thumb"
                :src="getImage(defStoneId, defStone.itemnumber[0], false)"
                :srcset="getImage(defStoneId, defStone.itemnumber[0], true)"
                :alt="defStone.itemnumber[0].toUpperCase()"
              />
              <p>
                {{ $t("Menu.list.stones.groups." + defStoneId) }}
              </p>
            </div>
          </template>
          <div
            v-if="
              possibleItems.list.common.inside &&
              possibleItems.list.common.inside.match === false
            "
            @click="changeItem(possibleItems.list.common.inside.itemnumber)"
            class="add-stone"
          >
            <img
              :src="appUrl + '/img/assets/stones/innen_g.jpg'"
              :srcset="appUrl + '/img/assets/stones/innen_g@2x.jpg'"
              class="thumb"
            />
            <p>
              {{ $t("Menu.list.stones.groups.inside") }}
            </p>
          </div>
          <div
            @click="changeItem(possibleItems.list.common.stone.itemnumber)"
            class="add-stone"
            v-if="
              possibleItems.list.common.stone &&
              possibleItems.list.common.stone.match === false
            "
          >
            <img
              :src="appUrl + '/img/assets/stones/settings/AA_g.jpg'"
              :srcset="appUrl + '/img/assets/stones/settings/AA_g@2x.jpg'"
              class="thumb"
            />
            <p>
              {{ $t("Menu.list.stones.groups.fromModel") }}
            </p>
          </div>
          <div
            @click="changeItem(possibleItems.list.common.left.itemnumber)"
            class="add-stone"
            v-if="possibleItems.list.common.left"
          >
            <img
              :src="appUrl + '/img/assets/stones/seite_links_g.jpg'"
              :srcset="appUrl + '/img/assets/stones/seite_links_g@2x.jpg'"
              class="thumb"
            />
            <p>
              {{ $t("Menu.list.stones.groups.left") }}
            </p>
          </div>
          <div
            @click="changeItem(possibleItems.list.common.right.itemnumber)"
            class="add-stone"
            v-if="possibleItems.list.common.right"
          >
            <img
              :src="appUrl + '/img/assets/stones/seite_rechts_g.jpg'"
              :srcset="appUrl + '/img/assets/stones/seite_rechts_g@2x.jpg'"
              class="thumb"
            />
            <p>
              {{ $t("Menu.list.stones.groups.right") }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="row"
        v-if="
          possibleItems.list.common.empty &&
          possibleItems.list.common.empty.match === false
        "
      >
        <div class="col-12 text-center">
          <button
            class="btn btn-secondary"
            @click="removeAll(possibleItems.list.common.empty.itemnumber)"
          >
            {{ $t("Menu.list.stones.groups.emptyAction") }}
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Config from "@/vuex/Config";
import SetData from "@/vuex/SetData";

export default {
  name: "StonesOvervies",
  props: ["possibleItems", "currentItem"],
  data() {
    return {
      itemData: {},
      imageHost: process.env.VUE_APP_IMAGE_HOST,
      getApiHost: Config.getters.getApiHost,
      appUrl: Config.getters.getAppUrl,
      currentItemId: SetData.getters.getCurrentItemId,
      summarizeStone: {
        show: false,
        fromGroup: null,
        toGroup: null,
      },
    };
  },
  updated() {
    this.setItem();
  },
  mounted() {
    this.setItem();
  },
  methods: {
    getStoneGroupTitle: function (stoneGroup, forInput) {
      let stoneGroupTitle = "";

      if (
        this.itemData &&
        this.itemData.description &&
        this.itemData.description.stones &&
        this.itemData.description.stones.groups &&
        this.itemData.description.stones.groups[stoneGroup]
      ) {
        if (
          this.itemData.description.stones.groups[stoneGroup]["libraryStone"]
        ) {
          stoneGroupTitle =
            this.itemData.description.stones.groups[stoneGroup]["libraryStone"];
        } else {
          stoneGroupTitle =
            this.itemData.description.stones.groups[stoneGroup]["setting"] +
            (!forInput ? "<br/>" : " ") +
            this.itemData.description.stones.groups[stoneGroup].number +
            " " +
            this.$t("Menu.list.stones.groups.total") +
            " " +
            this.$n(
              this.itemData.description.stones.groups[stoneGroup].size,
              "carat"
            ) +
            " " +
            "ct." +
            " " +
            this.$t("Menu.list.stones.groups.in") +
            " " +
            this.itemData.description.stones.groups[stoneGroup].quality.short;
        }
      }

      return stoneGroupTitle;
    },
    setItem: function () {
      if (typeof this.currentItem === "string") {
        let set = SetData.getters.getSet;
        this.itemData = set.items[0];
      } else {
        this.itemData = this.currentItem;
      }
    },
    removeAll: function (itemnumber) {
      if (!confirm(this.$t("Notifications.askBeforeAction"))) {
        return false;
      }
      this.changeItem(itemnumber);
    },
    changeItem: function (itemnumber) {
      this.$parent.$parent.changeItem(itemnumber);
    },
    changeItemByVarValue: function (varValue) {
      if (varValue.indexOf("drop") > -1) {
        if (!confirm(this.$t("Notifications.askBeforeAction"))) {
          return false;
        }
      }
      this.$parent.$parent.changeItemByVarValue(varValue);
    },
    configure: function (type) {
      this.$root.$emit("configure", type);
    },
    getImage: function (libraryStoneId, itemnumber, isRetina) {
      if (libraryStoneId == "def12") {
        return (
          this.appUrl +
          "/img/assets/stones/settings/CA_g" +
          (isRetina ? "@2x.jpg" : ".jpg")
        );
      } else if (libraryStoneId == "def1542") {
        return (
          this.appUrl +
          "/img/assets/stones/settings/DA_g" +
          (isRetina ? "@2x.jpg" : ".jpg")
        );
      } else {
        return (
          this.getApiHost +
          "/v2/images/item/ffffff/600/600/" +
          itemnumber.toUpperCase() +
          ".jpg"
        );
      }
    },
  },
  watch: {
    "possibleItems.list.summarize": function () {
      if (
        this.possibleItems.list.summarize &&
        this.possibleItems.list.summarize.length > 1
      ) {
        this.summarizeStone.fromGroup = this.possibleItems.list.summarize[0];
        this.summarizeStone.toGroup = this.possibleItems.list.summarize[1];
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  .col-2.text-end {
    display: flex;
    flex-direction: column; // vertikal stapeln
    align-items: flex-end; // rechtsbündig

    .icon {
      margin: 2.5em 0 0;
      width: 1.8rem;

      &.stone-group,
      &.stone {
        display: flex;
        margin: 0 0 1.5rem;
        padding: 0;

        cursor: pointer;
        flex-shrink: 0;
      }
    }
  }

  .stone-col {
    padding-right: 0;
  }

  .headline-stone-quality,
  .headline-stone-summarize {
    margin-bottom: 0.5rem;
    line-height: 2rem;
  }

  .row {
    select {
      margin-top: 1em;
      margin-bottom: 0.5em;
    }

    &.border-bottom {
      padding-bottom: 1rem;
    }

    div.add-stone {
      margin-top: 1em;
      vertical-align: top;
      cursor: pointer;
      display: flex;
      justify-content: flex-start;

      p {
        display: inline-flex;
        align-items: center;
        justify-content: flex-start;
        text-align: left;
        padding: 0 1.5rem;
      }
    }
  }

  .addon-list {
    position: relative;
    display: inline-flex;
    padding: 0;
    margin: 0;
    height: 5em;

    .addon-thumb-0,
    .addon-thumb-1,
    .addon-thumb-2,
    .addon-thumb-3,
    .addon-thumb-4 {
      width: 5rem;
      margin-left: 0;
      z-index: 50;
    }

    .addon-thumb-1 {
      z-index: 49;
      margin-left: -1em;
    }

    .addon-thumb-2 {
      z-index: 48;
      margin-left: -2em;
    }

    .addon-thumb-3 {
      z-index: 47;
      margin-left: -3em;
    }

    .addon-thumb-4 {
      z-index: 46;
      margin-left: -4em;
    }
  }

  .quality-line {
    line-height: 2em;
    padding: 0.5rem 0rem;
    cursor: pointer;
  }

  .quality-line.on {
    background-color: $lightGreyBg;
    font-weight: bold;
  }

  .quality-line:hover {
    background-color: $lightGreyBg;
  }

  .item-plan {
    max-width: 66rem;
    cursor: pointer;
  }
}
</style>
